import * as React from "react";
const SvgRightIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd", clipRule: "evenodd", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4 .755l14.374 11.245-14.374 11.219.619.781 15.381-12-15.391-12-.609.755z" }));
export { SvgRightIcon as ReactComponent };
